// The layout scrolls the window to the top on every page change. A page that
// restores its own scroll position (e.g. a list the user returns to) claims the
// navigation from a layout effect, which always runs before the layout's reset
// effect, and the reset skips that one navigation.
let claimedPathname = null;

export function claimScrollRestoration(pathname) {
  claimedPathname = pathname;
}

/** True once if `pathname` was claimed; always clears the claim. */
export function consumeScrollRestorationClaim(pathname) {
  const claimed = claimedPathname !== null && claimedPathname === pathname;
  claimedPathname = null;
  return claimed;
}
